import { Component, Input } from '@angular/core';
import { ImageAsset, ImageAssetType } from '../domain/types';
import { HttpImageComponent } from './http-image.component';


@Component({
  selector: 'crds-image-asset',
  template: `
    @if (images && images.length) {
      <div>
        @for (image of images; track image; let i = $index) {
          <div>
            @if (image && image.type) {
              <div>
                @switch (image.type) {
                  @case (ImageAssetType.ICON) {
                    <i
                      [class]="'material-icons ' + image.size"
                      [id]="key + '_' + i + '_temp'"
                      >
                      {{ image.getSrc() }}
                    </i>
                  }
                  @default {
                    <crds-http-image
                      class="asset-image"
                      [src]="image.getSrc()"
                      [alt]="key + ' ' + i + 1"
                      [id]="key + '_' + i + '_temp'"
                    ></crds-http-image>
                  }
                }
              </div>
            }
          </div>
        }
      </div>
    }
    `,
  imports: [HttpImageComponent]
})
export class ImageAssetComponent {
  @Input() images: ImageAsset[];
  @Input() key: string;

  ImageAssetType = ImageAssetType;
}
